module.exports = __webpack_public_path__ + "img/web.b79bbbd6.png";